import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';
import styles from './ACLoader.module.scss';

const propTypes = {
  active: PropTypes.bool,
  size: PropTypes.number,
};
const defaultProps = {
  active: false,
  size: 26,
};

//HOC for loading. If active is passed, then render CircularProgress, otherwise render children
const ACLoader = ({ active, size, children }) => {
  if (active) {
    return (
      <div className={styles.root}>
        <CircularProgress variant="indeterminate" size={size} />
      </div>
    );
  }
  return <>{children}</>;
};

ACLoader.propTypes = propTypes;
ACLoader.defaultProps = defaultProps;
export default ACLoader;
